import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { STORAGE_KEYS } from '@/constants/storage-keys.constants';

export interface UiState {
  globalLoading: boolean;
  globalError: string | null;
  sidebarCollapsed: boolean;
}

function getPersistedSidebarCollapsed(): boolean {
  return window.localStorage.getItem(STORAGE_KEYS.SIDEBAR_COLLAPSED) === 'true';
}

const initialState: UiState = {
  globalLoading: false,
  globalError: null,
  sidebarCollapsed: getPersistedSidebarCollapsed(),
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setGlobalLoading(state, action: PayloadAction<boolean>) {
      state.globalLoading = action.payload;
    },
    setGlobalError(state, action: PayloadAction<string | null>) {
      state.globalError = action.payload;
    },
    clearGlobalError(state) {
      state.globalError = null;
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
      window.localStorage.setItem(STORAGE_KEYS.SIDEBAR_COLLAPSED, String(action.payload));
    },
    toggleSidebarCollapsed(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      window.localStorage.setItem(STORAGE_KEYS.SIDEBAR_COLLAPSED, String(state.sidebarCollapsed));
    },
  },
});

export const {
  setGlobalLoading,
  setGlobalError,
  clearGlobalError,
  setSidebarCollapsed,
  toggleSidebarCollapsed,
} = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
